import script from "./PokedexView.vue?vue&type=script&setup=true&lang=js"
export * from "./PokedexView.vue?vue&type=script&setup=true&lang=js"

import "./PokedexView.vue?vue&type=style&index=0&id=198c9d5a&lang=scss"

const __exports__ = script;

export default __exports__